import { useContext, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { getEstimateInformationQuery } from '@widgets/EstimateInformation/api/hooks/getEstimateInformationQuery';
import { useHiddenEstimatesCount } from '@widgets/EstimateInformation/lib/hooks/useHiddenEstimatesCount';
import { EstimateInformationContext } from '@widgets/EstimateInformation/model/context';

export const useEstimateSettings = () => {
    const { data, isPending } = getEstimateInformationQuery();

    const { t } = useTranslation();

    const { onOpenCreateEstimateModal, isActiveSingleListSorting, onActiveSingleListSorting } =
        useContext(EstimateInformationContext);

    const [isShowAllEstimates, setIsShowAllEstimates] = useState(false);

    const handleToggleMoreEstimates = () => {
        setIsShowAllEstimates(true);
    };

    const { wrapperRef, hiddenCount } = useHiddenEstimatesCount();

    const isShowWorks =
        data?.parentEstimate || !!data?.childEstimates.length || data?.canAddChildEstimate;

    const isShowEstimates = !!data?.parentEstimate || !!data?.childEstimates.length;
    return {
        t,
        onOpenCreateEstimateModal,
        isActiveSingleListSorting,
        onActiveSingleListSorting,
        isShowAllEstimates,
        handleToggleMoreEstimates,
        wrapperRef,
        hiddenCount,
        isShowEstimates,
        data,
        isPending,
        isShowWorks,
    };
};
